import { Badge } from "@/components/ui/badge";

export const inputCls = "bg-white border-[var(--ir-border)] rounded-none focus-visible:ring-[var(--ir-blue)]";
export const outlineBtn = "border-[var(--ir-border)] bg-white text-[var(--ir-blue)] hover:bg-[var(--ir-surface2)] rounded-none h-8";
export const dangerBtn = "border-rose-300 bg-white text-rose-600 hover:bg-rose-50 rounded-none h-8";

export const emptyEdit = { name: "", email: "", phone: "", status: "pending", is_affiliate: false, access_code: "", code_active: false, commission_percent: "", promo_code: "" };

export const StatCard = ({ icon: Icon, label, value, accent }) => (
  <div className="bg-white p-6 border border-[var(--ir-border)] rounded-lg soft-shadow" data-testid={`stat-${label.toLowerCase().replace(/\s/g, "-")}`}>
    <div className="flex items-center justify-between">
      <span className="text-[var(--ir-muted)] text-sm">{label}</span>
      <Icon className={`w-5 h-5 ${accent}`} />
    </div>
    <div className="font-display text-4xl mt-3 text-[var(--ir-text)]">{value ?? "—"}</div>
  </div>
);

export const statusBadge = (status) => {
  const map = {
    approved: "bg-[var(--ir-blue)]/10 text-[var(--ir-blue)] border-[var(--ir-blue)]/25",
    pending: "bg-[var(--ir-orange)]/10 text-[var(--ir-orange)] border-[var(--ir-orange)]/30",
    suspended: "bg-rose-500/10 text-rose-600 border-rose-500/30",
  };
  return <Badge className={`rounded-none border capitalize ${map[status] || map.pending}`}>{status}</Badge>;
};

export const codeBadge = (m) => {
  if (!m.access_code) return <Badge className="rounded-none border bg-[var(--ir-surface2)] text-[var(--ir-muted)] border-[var(--ir-border)]">No code</Badge>;
  return m.code_active
    ? <Badge className="rounded-none border bg-emerald-500/10 text-emerald-600 border-emerald-500/30">Active</Badge>
    : <Badge className="rounded-none border bg-rose-500/10 text-rose-600 border-rose-500/30">Inactive</Badge>;
};
